import { Card, Col, Row, Tooltip, Typography } from "antd";
import Image from "next/image";
import React from "react";
import { useIntl } from "react-intl";
import { calculateAgeGroup, getProductCodeFromTrainClassType } from "../../Lib/Utils/validationUtil";
import { IBookedTrips, IBookItAgainTripItemProps } from "../../Orchestrator/Types/Index";
import { ProductCodeEnum } from "../../Orchestrator/Types/Enums/globalDefaultEnum";
import "./BookItAgainTripItem.css"; // Assuming you have a CSS file for styles
import stopManager from "../../Lib/Utils/StopManager";

const BookItAgainTripItem: React.FC<IBookItAgainTripItemProps> = ({
  trip,
  onShowModal,
}) => {
  const intl = useIntl();
  return (
    <Card
      type="inner"
      className="trip-item"
    >
      <Row gutter={[0, 16]} justify={"space-between"} align="middle" >
        <Col>
          <div className="book-again-trip-route-info-container">
            <div className="image">
              {trip.bookingType === "oneWayTrip" ? (
                <Image
                  src="/assets/booking/arrow-down-small.svg"
                  width={24}
                  height={24}
                  alt="one way"
                  className="booking-arrow"
                />
              ) : (
                <Image
                  src="/assets/booking/arrow-down-arrow-up.svg"
                  width={24}
                  height={24}
                  alt="round"
                  className="booking-arrow"
                />
              )}
            </div>
            <div className="book-again-trip-route-info">
              <Typography className="fs-20 fw-700">{stopManager.getStopNameById(trip.from || trip.fromName)}</Typography>
              <Typography className="fs-20 fw-700">{stopManager.getStopNameById(trip.to || trip.toName)}</Typography>
            </div>
          </div>
        </Col>

        <Col className="book-again-trip-info-col">
          <div className="book-again-trip-info-container">
            <Row justify="space-between" align="middle">
              <Col>
                <Row>
                  <div className="fw-500 fs-16">
                    {trip.departureTime} - {trip.arrivalTime}
                  </div>
                </Row>
                <Row className="fw-500 fs-16 align-items-center">
                  <Col
                    className="fs-16 fw-500 color-757575"
                    style={{
                      maxWidth: "140px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Tooltip title={calculateAgeGroup(trip.passengers, intl)}>
                      {calculateAgeGroup(trip.passengers, intl)}
                    </Tooltip>
                  </Col>
                  <Typography className="fs-10 color-757575">
                    &nbsp;
                    &nbsp;
                    &#9679;
                    &nbsp;
                    &nbsp;
                  </Typography>
                  <Col
                    className="fw-600 fs-16"
                    style={{
                      color:
                        trip.summary === ""
                          ? "inherit"
                          : getProductCodeFromTrainClassType(trip?.selectedPriceClass || "") === ProductCodeEnum.PFF
                            ? "#143D8C"
                            : "#34c2a2",
                      maxWidth: "140px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {trip?.selectedPriceClass && (
                      <Tooltip title={trip?.productName}>
                        {trip?.productName}
                      </Tooltip>
                    )}
                  </Col>
                </Row>
              </Col>

              <Col>
                <div className="align-items-center h-100">
                  <button
                    className="danger-btn justify-content-center align-items-center w-100 text-center custom_space radius-20"
                    onClick={() => onShowModal(trip as IBookedTrips)}
                  >
                    <span className="mr-5 fs-14">{intl.formatMessage({ id: "book" })}</span>
                    <Image
                      src={"/assets/booking/right_small_arrow.svg"}
                      alt="book"
                      width={14}
                      height={10}
                    />
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default BookItAgainTripItem;
